// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueCookies from 'vue-cookies'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n'
import messages from '@/plugins/i18n'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(VueAxios, axios)

Vue.use(VueCookies)

Vue.use(VueI18n)


const i18n = new VueI18n({
  locale: 'hy', // set locale
  fallbackLocale: 'hy', // set fallback locale
  messages, // set locale messages
})

// Vue.prototype.$request = 'http://panino.local/'
// Vue.prototype.$request = 'http://127.0.0.1:8000/'
Vue.prototype.$request = 'https://admin.panino.am/'

axios.get(Vue.prototype.$request + 'get_token/', ).then((response) => {
  axios.defaults.headers.common['X-CSRFToken'] = response.data.token
  axios.get(Vue.prototype.$request + 'configs').then((response) => {
    Vue.prototype.$configs = JSON.parse(response.data.configs)[0]
    Vue.prototype.$products = JSON.parse(response.data.products)
    Vue.prototype.$gallery = JSON.parse(response.data.gallery)
    Vue.prototype.$gallery_categories = JSON.parse(response.data.gallery_categories)
    Vue.prototype.$gallery_show_on_home_page = JSON.parse(response.data.gallery_show_on_home_page)
    Vue.prototype.$available_cities = JSON.parse(response.data.available_cities)
    new Vue({
      el: '#app',
      i18n,
      router,
      components: {
        App,
      },
      template: '<App/>'
    })
  })
})








// WEBPACK FOOTER //
// ./src/main.js